import request from '@/utils/request'

// 行业动态列表
export function industryList(query) {
    return request({
        url: '/material/industry/plasticizerNewsList',
        method: 'get',
        params: query
    })
}

// 行业动态详情
export function industryDetail(id) {
    return request({
        url: `/material/industry/plasticizerNews/${id}`,
        method: 'get',
    })
}

// 上游价格列表
export function priceList(query) {
    return request({
        url: '/material/metatron/price/anhydrideUpPriceList',
        method: 'get',
        params: query
    })
}

// 上游价格详情
export function priceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsAnhydrideDownProfitList`,
        method: 'get',
        params:query
    })
}

// 装置动态列表
export function deviceList(query) {
    return request({
        url: '/material/industry/anhydrideDeviceList',
        method: 'get',
        params: query
    })
}

// 装置动态详情
export function deviceDetail(id) {
    return request({
        url: `/material/industry/anhydrideDevice/${id}`,
        method: 'get',
    })
}

// 研究报告列表
export function reportList(query) {
    return request({
        url: '/material/report/reportPlasticizerList',
        method: 'get',
        params: query
    })
}

// 研究报告详情
export function reportDetail(id) {
    return request({
        url: `/material/report/boardPlasticizerInfo/${id}`,
        method: 'get',
    })
}

// 技术及标准列表
export function standardList(query) {
    return request({
        url: '/material/report/plasticizerList',
        method: 'get',
        params: query
    })
}

// 技术及标准详情
export function standardDetail(id) {
    return request({
        url: `/material/report/technicalPlasticizerInfo/${id}`,
        method: 'get',
    })
}

// 进出口列表
export function exitList(query) {
    return request({
        url: '/material/industry/anhydrideExitList',
        method: 'get',
        params: query
    })
}

// 进出口详情
export function exitDetail(id) {
    return request({
        url: `/material/industry/anhydrideExit/${id}`,
        method: 'get',
    })
}

// 产量列表
export function yieldList(query) {
    return request({
        url: '/material/industry/anhydrideYieldList',
        method: 'get',
        params: query
    })
}

// 产量详情
export function yieldDetail(id) {
    return request({
        url: `/material/industry/asphaltYield/${id}`,
        method: 'get',
    })
}

// 利润列表
export function profitList(query) {
    return request({
        url: '/material/metatron/price/anhydrideProfitList',
        method: 'get',
        params: query
    })
}

// 利润详情
export function profitDetail(query) {
    return request({
        url: `/material/metatron/price/detailsAnhydrideProfitList`,
        method: 'get',
        params:query
    })
}

// 开工率列表
export function rateList(query) {
    return request({
        url: '/material/metatron/rate/rateAnhydrideList',
        method: 'get',
        params: query
    })
}

// 开工率详情
export function rateDetail(query) {
    return request({
        url: `/material/metatron/rate/detailsAnhydrideList`,
        method: 'get',
        params:query
    })
}

// 增塑剂价格列表
export function addPriceList(query) {
    return request({
        url: '/material/metatron/price/plasticizerPriceList',
        method: 'get',
        params: query
    })
}

// 增塑剂价格详情
export function addPriceDetail(query) {
    return request({
        url: `/material/metatron/price/detailsPlasticizerPriceList`,
        method: 'get',
        params:query
    })
}

// 增塑剂开工率列表
export function addRateList(query) {
    return request({
        url: '/material/industry/plasticizerRateList',
        method: 'get',
        params: query
    })
}

// 增塑剂开工率详情
export function addRateDetail(id) {
    return request({
        url: `/material/industry/plasticizerRate/${id}`,
        method: 'get',
    })
}

// 增塑剂产量列表
export function addYieldList(query) {
    return request({
        url: '/material/metatron/yield/plasticizerYieldList',
        method: 'get',
        params: query
    })
}

// 增塑剂产量详情
export function addYieldDetail(query) {
    return request({
        url: `/material/metatron/yield/detailsPlasticizerYieldList`,
        method: 'get',
        params:query
    })
}

// 增塑剂利润列表
export function addProfitList(query) {
    return request({
        url: '/material/metatron/price/plasticizerProfitList',
        method: 'get',
        params: query
    })
}

// 增塑剂利润详情
export function addProfitDetail(query) {
    return request({
        url: `/material/metatron/price/detailsPlasticizerProfitList`,
        method: 'get',
        params:query
    })
}

// 减水剂列表
export function cutWaterList(query) {
    return request({
        url: '/material/metatron/exit/anhydrideWaterList',
        method: 'get',
        params: query
    })
}

// 减水剂详情
export function cutWaterDetail(query) {
    return request({
        url: `/material/metatron/exit/detailsAnhydrideWaterList`,
        method: 'get',
        params:query
    })
}

// 折线图
export function priceDetailData(query) {
    return request({
        url: `/material/metatron/detail/lineChart`,
        method: 'get',
        params:query
    })
}
